"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useLockBodyScroll = (isLocked, originalOverflow = 'auto') => {
    (0, react_1.useEffect)(() => {
        const lockScroll = () => {
            document.body.style.overflow = 'hidden';
        };
        const unlockScroll = () => {
            document.body.style.overflow = originalOverflow;
        };
        if (isLocked) {
            lockScroll();
        }
        else {
            unlockScroll();
        }
        return () => {
            unlockScroll();
        };
    }, [isLocked, originalOverflow]);
};
exports.default = useLockBodyScroll;
